import Vue from "vue";

export async function index() {
  const response = await Vue.prototype.$http.get(`/authorized_devices`);

  return response.data.data;
}

export async function authorize(id) {
  const response = await Vue.prototype.$http.post(
    `/authorized_devices/authorize/${id}`
  );

  return response.data.data;
}

export async function destroy(id) {
  const response = await Vue.prototype.$http.delete(
    `/authorized_devices/${id}`
  );

  return response;
}
